import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Background from '../../../atoms/Background'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 'inherit',
    backgroundPosition: 'bottom center'
  },
  content: {
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  [theme.breakpoints.down('xs')]: {
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      minHeight: '100%',
      height: 'auto',
      margin: '1rem 0',
      padding: '0 1rem'
    }
  }
}))

const DashboardLayout = ({ backgroundImage, darkBackgroundUrl, backgroundStyles, children, className, contentClassName }) => {
  const classes = useStyles({ backgroundImage })

  const containerClassNames = clsx(classes.container, { [className]: Boolean(className) })
  const contentClassNames = clsx(classes.content, { [contentClassName]: Boolean(contentClassName) })

  return (
    <Background lightUrl={backgroundImage} darkUrl={darkBackgroundUrl} className={containerClassNames} style={{ ...(backgroundStyles || {}) }}>
      <div className={contentClassNames}>{children}</div>
    </Background>
  )
}

DashboardLayout.propTypes = {
  backgroundImage: PropTypes.string,
  darkBackgroundUrl: PropTypes.string,
  backgroundStyles: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string
}

export default DashboardLayout
